export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14656.220db8f7.jpg";